module.exports = __webpack_public_path__ + "static/media/LT.6515d284.png";